import React, {useEffect} from 'react';
import styles from '../../../shared/student/earned-referral-section/styles.module.scss';
import ProgressBar from '../../../shared/components/progress-bar';
import classnames from 'classnames';
import 'stylesheets/components/nav-bar-invite-list.scss';
import {filter, includes} from 'lodash';
import {MAX_INVITES} from './sent-invitations';
import {withCommas} from '../../../shared/utils';
import {useDispatch, useSelector} from 'react-redux';
import {fetchInvitations} from 'src/redux/studentReferralModal/actions';
import {Store} from 'src/types/store';

interface EarnedReferralSectionProps {
  awardAmount: number;
}

const EarnedReferralSection = ({awardAmount}: EarnedReferralSectionProps): React.ReactElement => {
  const dispatch = useDispatch();
  const invitations = useSelector((state: Store) => state.referralModal.invitations);

  useEffect(() => {
    if (!invitations && fetchInvitations) {
      dispatch(fetchInvitations());
    }
  }, []);

  const tempAmount = filter(invitations, (invite) => includes(invite.status, 'Earned')).length;

  const amount = Math.min(tempAmount, MAX_INVITES);

  const fillAmount = ((Math.min(amount, MAX_INVITES) / MAX_INVITES) * 100).toFixed(0) + '%';

  return (
    <div>
      <div className={classnames(styles.earningsText, styles.paddingBottom, styles.centerText)}>
        <span>You&apos;ve earned</span>
        <span className={styles.earnedText}> ${withCommas(amount * awardAmount)}</span>
        <span> of ${withCommas(awardAmount * 10)}</span>
      </div>
      <div className={styles.centerContent}>
        <ProgressBar color="blue" fillAmount={fillAmount} width="90%" height={15} />
      </div>
    </div>
  );
};

export default EarnedReferralSection;
